/** Inline line icons, drawn on a 24-unit grid with square caps. */
const PATHS = {
  map: 'M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2V6zm6-2v14m6-12v14',
  empire: 'M3 21h18M5 21V10l7-5 7 5v11M9 21v-6h6v6',
  close: 'M6 6l12 12M18 6L6 18',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  tilt: 'M4 18l8-12 8 12H4zm4-4h8',
  flat: 'M4 6h16v12H4z',
  turf: 'M4 20V6l5-2v14M9 18l6 2V6l-6-2M15 6l5-2v14l-5 2',
  locate: 'M12 3v3m0 12v3M3 12h3m12 0h3M12 8a4 4 0 100 8 4 4 0 000-8z',
  chevronDown: 'M6 9l6 6 6-6',
  chevronUp: 'M6 15l6-6 6 6',
  layers: 'M12 3l9 5-9 5-9-5 9-5zm-9 9l9 5 9-5m-18 4l9 5 9-5',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 9a7 7 0 0114 0',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h11',
  globe: 'M12 3a9 9 0 100 18 9 9 0 000-18zm-9 9h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18',
  arrowRight: 'M5 12h14m-5-5l5 5-5 5',
  sort: 'M8 9l4-4 4 4M8 15l4 4 4-4',
} as const

export type IconName = keyof typeof PATHS

export function Icon({ name, size = 18, className = '' }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="square"
      strokeLinejoin="miter"
      aria-hidden
      className={className}
    >
      <path d={PATHS[name]} />
    </svg>
  )
}
